import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Camera, CheckCircle2 } from "lucide-react";

/** État contradictoire au chargement : photo du bien + anomalies constatées. */
export default function PickupProofDialog({ open, onOpenChange, onConfirm, loading }) {
  const [photo, setPhoto] = useState(null);
  const [notes, setNotes] = useState("Aucune anomalie constatée");

  useEffect(() => {
    if (!open) {
      setPhoto(null);
      setNotes("Aucune anomalie constatée");
    }
  }, [open]);

  const handleFile = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setPhoto(reader.result);
    reader.readAsDataURL(file);
  };
  const ready = Boolean(photo && notes.trim().length > 1);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="pickup-proof-dialog">
        <DialogHeader>
          <DialogTitle>Constater le chargement</DialogTitle>
          <p className="text-sm text-muted-foreground">
            Photographiez la marchandise au départ et indiquez toute anomalie avant de quitter le site.
          </p>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="overline">Photo au chargement</Label>
            <div className="mt-1">
              {photo ? (
                <div className="relative border border-[#1F4032]/15 rounded-md overflow-hidden">
                  <img src={photo} alt="État au chargement" className="w-full max-h-56 object-contain bg-neutral-50" />
                  <button type="button" onClick={() => setPhoto(null)} className="absolute top-2 right-2 bg-white/90 text-xs px-2 py-1 rounded-md" data-testid="pickup-photo-reset">
                    Reprendre
                  </button>
                </div>
              ) : (
                <label className="cursor-pointer flex items-center justify-center gap-2 h-32 border-2 border-dashed border-[#1F4032]/20 rounded-md hover:bg-[#1F4032]/5" data-testid="pickup-photo-upload-label">
                  <Camera className="w-5 h-5 text-[#1F4032]" />
                  <span className="text-sm">Prendre une photo / choisir un fichier</span>
                  <input type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => handleFile(e.target.files?.[0])} data-testid="pickup-photo-upload" />
                </label>
              )}
            </div>
          </div>
          <div>
            <Label className="overline">État et réserves au départ</Label>
            <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} className="mt-1" data-testid="pickup-condition-notes" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={loading}>Annuler</Button>
          <Button disabled={!ready || loading} onClick={() => onConfirm({ pickup_proof_photo: photo, pickup_condition_notes: notes.trim() })} className="bg-[#1F4032] hover:bg-[#2A5443] gap-2" data-testid="pickup-proof-confirm">
            <CheckCircle2 className="w-4 h-4" />
            {loading ? "Enregistrement…" : "Confirmer le chargement"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
